const GET_REFRESH_PURCHASE_ORDER = 'GET_REFRESH_PURCHASE_ORDER'
const SET_REFRESH_PURCHASE_ORDER = 'SET_REFRESH_PURCHASE_ORDER'

const GET_PO_PDF_LINK_PONUMBER = 'GET_PO_PDF_LINK_PONUMBER'
const SET_PO_PDF_LINK_PONUMBER = 'SET_PO_PDF_LINK_PONUMBER'

export{ 
    GET_REFRESH_PURCHASE_ORDER,
    SET_REFRESH_PURCHASE_ORDER,
    GET_PO_PDF_LINK_PONUMBER,
    SET_PO_PDF_LINK_PONUMBER
}